import React from "react";
import { Link } from "react-router-dom";
import placeholderImage from "../../Assets/Images/placeholder_image.png";
import './style.css'
import { isValidString } from "../../helper";
import { WEB_URL } from "../../redux/actions/config";

const SimpleCard = ({ data, event_id }) => {

  return (
    <div className="competitions-content-slider col-md-4 px-2 mx-auto my-5">
      <div className="competitions-item">
        <Link><img className="chmpn-slider-img" src={isValidString(data?.activityDetails?.mediaList[0]?.url) ? data?.activityDetails?.mediaList[0]?.url : placeholderImage} /></Link>
        <div class="chmpn-slider-content chmpn-register-select-btn">
          <Link class="nav-link" to="/champion-details" state={{ data: { ...data, event_id } }}><span>{data?.name}</span></Link>
          <Link class="nav-link explore-nav" to="/champion-details" state={{ data: { ...data, event_id } }}>Explore more</Link>
        </div>
      </div>
    </div>
  );
};

export default SimpleCard;
